import { Component, OnInit } from '@angular/core';
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";

@Component({
  selector: 'app-template-types-page',
  templateUrl: './template-types-page.component.html',
  styles: []
})
export class TemplateTypesPageComponent implements OnInit {

  VAL_TYPES = VALUE_TYPE;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Типы шаблонов закаов");

  document:IDocument;

  collectionParams = paramsHelper.collection()
    .setDuplicateEnabled(false)
    .setDefaultListLabels()
    .setItemLabelQuery('name')
    .setObjectType(DOCUMENT_TYPES.ORDER_TEMPLATE_TYPE);

  constructor(private busService:BusService) { }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IDocument));
  }

  private updateDocument(document:IDocument){
    this.document = document;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/template-types-page/template-types-page.component.ts